import React from 'react'
import "./Title.css";

export default function Title({SubTitle,Title}) {
  return (
    <div className='title'>
        <p>{SubTitle}</p>
        <h2>{Title}</h2>
    </div>
  )
}
